module.exports = __webpack_public_path__ + "static/img/img-home-co-19.73384b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-19.png
// module id = UyTQ
// module chunks = 1